<template>
  <div>
    <div class="mx-3" style="max-width: 400px">
      <v-select
        v-if="!logbooksTabSelected"
        v-model="coordinatedUser"
        :loading="!usersfectched"
        label="Interno"
        item-value="id"
        :items="coordinatedUsers"
        single-line
      >
        <template v-slot:prepend-inner>
          <Icon name="home-user" />
        </template>
        <template v-slot:selection="{ item }">
          {{ item.firstName }} {{ item.lastName }}
        </template>
        <template v-slot:item="{ item }">
          {{ item.firstName }} {{ item.lastName }}
        </template>
      </v-select>

      <v-select
        v-if="logbooksTabSelected"
        multiple
        v-model="selectedUsers"
        :loading="!usersfectched"
        label="Internos"
        item-value="id"
        item-text="userName"
        :items="coordinatedUsers"
        hint="Seleccione um ou mais internos para ver os seus registos"
        persistent-hint
        clearable
      >
      </v-select>
    </div>
    <template v-if="usersfectched">
      <CoordinationComponent
        :selectedUsers="selectedUsers"
        :onChangeTab="
          isLogbooksTabSelected => {
            logbooksTabSelected = isLogbooksTabSelected
          }
        "
        :coordinatedUser="coordinatedUser"
        :coordinatedUsers="coordinatedUsers"
      />
    </template>
  </div>
</template>

<script>
import { CoordinatedUsers } from '../../models/CoordinatedUsers'
import CoordinationComponent from './components/CoordinationComponent.vue'
import specialtyFetcher from '@/mixins/specialtyFetcher'
import _ from 'lodash'
export default {
  components: {
    CoordinationComponent
  },
  mixins: [specialtyFetcher],
  data() {
    return {
      coordinatedUser: '',
      selectedUsers: [],
      usersfectched: false,
      logbooksTabSelected: true
    }
  },

  computed: {
    coordinatedUsers() {
      const users = _.orderBy(CoordinatedUsers.query().get(), [
        'firstName',
        'lastName'
      ])
        .map(u => ({ ...u, userName: `${u.firstName} ${u.lastName}` }))
        .filter(i => i.id != this.$store.getters.profile.id)
      return users
    }
  },

  async created() {
    await Promise.all([
      CoordinatedUsers.fetch(
        this.$store.getters.accessToken,
        this.$store.getters.user.roles,
        this.$store.getters.user.email,
        this.$store.getters.user.hospital,
        this.$store.getters.user.specialty
      ),
      this.fetchSpecialty()
    ]).catch(err => {
      return this.$store.dispatch(
        'showErrorSnackbar',
        err.message || 'Something went wrong'
      )
    })
    this.usersfectched = true
    if (this.$route.params.coordinatedUser) {
      this.coordinatedUser = this.$route.params.coordinatedUser
    } else {
      this.coordinatedUser = this.coordinatedUsers.length
        ? this.coordinatedUsers[0].id
        : ''
    }
  }
}
</script>
<style></style>
